export default "__VITE_ASSET__CGz1eZOO__"